import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PersonUsesBookService } from '../../person-uses-book.service';
import { catchError, exhaustMap, filter, map, of } from 'rxjs';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { PersonUsesBookActions } from './person-uses-book.actions';
import { PersonUsesBookFacade } from './person-uses-book.facade';
import { HomePageActions } from '@lyceo/lyceo-pupil-app/home/data-access';
import { PermissionService } from '@lyceo/shared/permissions/data-access';
import { Permission } from '@lyceo/lyceo-pupil-app/shared/util-models';

@Injectable()
export class PersonUsesBookEffects {
  private readonly actions$ = inject(Actions);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);
  private readonly personUsesBookService = inject(PersonUsesBookService);
  private readonly personUsesBookFacade = inject(PersonUsesBookFacade);
  private readonly permissionService = inject(PermissionService);

  public latestPersonUsesBooksLoaded$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(HomePageActions.init),
      exhaustMap(() =>
        this.permissionService.hasPermission(Permission.PRACTICE_MODULE).pipe(
          filter(
            (permission) =>
              permission && !this.personUsesBookFacade.latestLoaded(),
          ),
          map(() => PersonUsesBookActions.getLatestPersonUsesBooks()),
        ),
      ),
    );
  });

  public getLatestPersonUsesBooks$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PersonUsesBookActions.getLatestPersonUsesBooks),
      exhaustMap(() =>
        this.personUsesBookService.getLatestPersonUsesBooks().pipe(
          map((personUsesBookResponse) =>
            PersonUsesBookActions.getLatestPersonUsesBooksSuccess({
              personUsesBooks:
                personUsesBookResponse.personUsesBookWithBookProgresses,
            }),
          ),
          catchError((error: Error) =>
            of(
              PersonUsesBookActions.getLatestPersonUsesBooksFailure({ error }),
            ),
          ),
        ),
      ),
    );
  });

  public getLatestPersonUsesBooksFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(PersonUsesBookActions.getLatestPersonUsesBooksFailure),
        map(() => {
          this.applicationFacade.showToaster({
            type: 'error',
            message: 'Het laden van de meest recente vakken is niet gelukt.',
          });
        }),
      );
    },
    { dispatch: false },
  );
}
